const WORKING_START_OFFSET_X = 40;
const WORKING_START_OFFSET_Y = 30;

/** A frame's rect in client pixels (`lib/frame-screen-rect.ts`). */
export interface FrameScreenRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function frameWorkingStartCursorAnchor(rect: FrameScreenRect): {
  x: number;
  y: number;
} {
  return {
    x: rect.left + WORKING_START_OFFSET_X,
    y: rect.top + WORKING_START_OFFSET_Y,
  };
}
